const config = {
  API_URL: import.meta.env.VITE_API_URL ||
    (document.location.host.includes("localhost")
      ? "http://localhost:8000/v1"
      : document.location.host.includes("dopeassdevs.co.za")
        ? "https://api.dopeassdevs.co.za/v1"
        : document.location.host.includes("-staging")
          ? "https://api.mobile.deeliver-staging.co.za/v1"
          : "https://api.mobile.deeliver.co.za/v1"),

  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',

  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID || '',

  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',

  /**
   * Uber Gateway Lambda URL for promotion management
   * Calls go directly to the Lambda (API key auth, not JWT)
   */
  UBER_LAMBDA_URL: import.meta.env.VITE_UBER_LAMBDA_URL ||
    (document.location.host.includes("localhost")
      ? 'https://uber.deeliver-staging.co.za'
      : document.location.host.includes("dopeassdevs.co.za")
        ? 'https://uber.deeliver-staging.co.za'
        : document.location.host.includes('-staging')
          ? 'https://uber.deeliver-staging.co.za'
          : 'https://uber.deeliver.co.za'),

  /**
   * API key for the Uber Gateway Lambda admin endpoints
   */
  UBER_LAMBDA_API_KEY: import.meta.env.VITE_UBER_LAMBDA_API_KEY || '',

  /**
   * SKC Webhook API Gateway URL (for auth testing)
   */
  SKC_GATEWAY_URL: import.meta.env.VITE_SKC_GATEWAY_URL ||
    (document.location.host.includes("localhost")
      ? 'https://skc.deeliver-staging.co.za'
      : document.location.host.includes("dopeassdevs.co.za")
        ? 'https://skc.deeliver-staging.co.za'
        : document.location.host.includes('-staging')
          ? 'https://skc.deeliver-staging.co.za'
          : 'https://skc.deeliver.co.za'),
};

export default config;
